/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-02 19:29:27
 * Copyright 2022 Leedarson, All Rights Reserved.
 */
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Login from '@root/pages/Login';
import Home from '@root/pages/Home';
import ApplePay from '@root/pages/ApplePay';
import ApplePaySelectDevice from '@root/pages/ApplePay/SelectDevice';
import GiftCard from '@root/pages/GiftCard';
import GiftCardPackages from '@root/pages/GiftCard/Packages';
import GiftCardSelectDevice from '@root/pages/GiftCard/SelectDevice';
import GiftCardRenewal from '@root/pages/GiftCard/Renewal';
import GiftCardPayMethod from '@root/pages/GiftCard/PayMethod';
import NewSubscription from '@root/pages/NewSubscription';
import SubscriptionDetail from '@root/pages/Subscription/Detail';
import SubscriptionSelectDevice from '@root/pages/NewSubscription/SelectDevice';
import SubscriptionDetailAdjustDevice from '@root/pages/Subscription/AdjustDevice';
import SubscriptionRemoveDevice from '@root/pages/Subscription/RemoveDevice';

import RedirectLogin from './RedirectLogin';
import PaySuccess from '@root/pages/PaySuccess';
import PayFail from '@root/pages/PayFail';
import BillAddress from '@root/pages/Bill/Address';
import BillDetail from '@root/pages/Bill/Detail';
import BillList from '@root/pages/Bill/List';
import SelectCountry from '@root/pages/Bill/SelectCountry';
import LoginSelectCountry from '@root/pages/Login/SelectCountry';
import SecondCertification from '@root/pages/Login/SecondCertification';
import DefaultPackagePage from '@root/pages/DefaultPackage';
import DefaultPackageSelectDevice from '@root/pages/DefaultPackage/SelectDevice';
import PackageRenewal from '@root/pages/PackageRenewal';
import UpdatePackageDevice from '@root/pages/Subscription/UpdatePackageDevice';
import PromotionsPackage from '@root/pages/Promotions';
import PromotionsSelectDevice from '@root/pages/Promotions/SelectDevice';

const RenderRoute = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <RedirectLogin>
            <Home />
          </RedirectLogin>
        }
      />
      <Route path="/login/certification" element={<SecondCertification />} />
      <Route path="/login" element={<Login />} />
      <Route path="/selectCountry" element={<LoginSelectCountry />} />
      <Route
        path="/paySuccess/*"
        element={
          <RedirectLogin>
            <PaySuccess />
          </RedirectLogin>
        }
      />
      <Route
        path="/payFailed/*"
        element={
          <RedirectLogin>
            <PayFail />
          </RedirectLogin>
        }
      />
      <Route
        path="/subscription/:id"
        element={
          <RedirectLogin>
            <SubscriptionDetail />
          </RedirectLogin>
        }
      />

      <Route
        path="/subscription/:id/adjustDevice"
        element={
          <RedirectLogin>
            <SubscriptionDetailAdjustDevice />
          </RedirectLogin>
        }
      />

      <Route
        path="/subscription/:id/adjustDevice/remove"
        element={
          <RedirectLogin>
            <SubscriptionRemoveDevice />
          </RedirectLogin>
        }
      />

      <Route
        path="/subscription/:id/updateDevice"
        element={
          <RedirectLogin>
            <UpdatePackageDevice />
          </RedirectLogin>
        }
      />

      <Route
        path="/defaultPackage"
        element={
          <RedirectLogin>
            <DefaultPackagePage />
          </RedirectLogin>
        }
      />

      <Route
        path="/defaultPackage/selectDevice"
        element={
          <RedirectLogin>
            <DefaultPackageSelectDevice />
          </RedirectLogin>
        }
      />

      <Route
        path="/package/renewal"
        element={
          <RedirectLogin>
            <PackageRenewal />
          </RedirectLogin>
        }
      />

      <Route
        path="/packages"
        element={
          <RedirectLogin>
            <NewSubscription />
          </RedirectLogin>
        }
      />

      <Route
        path="/packages/:packageId/selectDevice"
        element={
          <RedirectLogin>
            <SubscriptionSelectDevice />
          </RedirectLogin>
        }
      />

      <Route
        path="/giftCard"
        element={
          <RedirectLogin>
            <GiftCard />
          </RedirectLogin>
        }
      />
      <Route
        path="/giftCard/:code/packages"
        element={
          <RedirectLogin>
            <GiftCardPackages />
          </RedirectLogin>
        }
      />
      <Route
        path="/giftCard/renewal/:packageId"
        element={
          <RedirectLogin>
            <GiftCardRenewal />
          </RedirectLogin>
        }
      />
      <Route
        path="/giftCard/:code/packages/:packageId/payMethod"
        element={
          <RedirectLogin>
            <GiftCardPayMethod />
          </RedirectLogin>
        }
      />
      <Route
        path="/giftCard/:code/packages/:packageId/selectDevice"
        element={
          <RedirectLogin>
            <GiftCardSelectDevice />
          </RedirectLogin>
        }
      />
      <Route
        path="/applePay"
        element={
          <RedirectLogin>
            <ApplePay />
          </RedirectLogin>
        }
      />
      <Route
        path="/applePay/selectDevice"
        element={
          <RedirectLogin>
            <ApplePaySelectDevice />
          </RedirectLogin>
        }
      />

      <Route
        path="/billAddress"
        element={
          <RedirectLogin>
            <BillAddress />
          </RedirectLogin>
        }
      />

      <Route
        path="/billAddress/selectCountry"
        element={
          <RedirectLogin>
            <SelectCountry />
          </RedirectLogin>
        }
      />

      <Route
        path="/bills"
        element={
          <RedirectLogin>
            <BillList />
          </RedirectLogin>
        }
      />

      <Route
        path="/bills/:id"
        element={
          <RedirectLogin>
            <BillDetail />
          </RedirectLogin>
        }
      />

      <Route
        path="/promotions/selectDevice"
        element={
          <RedirectLogin>
            <PromotionsSelectDevice />
          </RedirectLogin>
        }
      />

      <Route
        path="/promotions"
        element={
          <RedirectLogin ignoreToken>
            <PromotionsPackage />
          </RedirectLogin>
        }
      />
      {/* <Route path="*" element={<NotFound />} /> */}
    </Routes>
  );
};

export default RenderRoute;
